<template>
  <el-container v-title data-title="订单查询" style="min-height:98vh">
    <el-header style="text-align: right; font-size: 12px; height: 105px; background-image: linear-gradient(to right, white , green);">
      <Top/>
    </el-header>
    <el-container>
      <el-aside width="200px" style="background-color: rgb(238, 241, 246)">
        <Menu @GoTo='goto'></Menu>
      </el-aside>
      <el-main style="width: 1px">
        <el-header style="height: auto; padding: 0; background-color: #FFF">
          <el-container>
            <el-header height="20px" style="padding: 0; background-color: #FFF">
              <el-breadcrumb separator="/">
                <el-breadcrumb-item>学生点餐</el-breadcrumb-item>
                <el-breadcrumb-item>订单查询</el-breadcrumb-item>
              </el-breadcrumb>
            </el-header>
            <el-main>
              <el-form :inline="true" :model="searchForm" class="demo-form-inline" >
                <el-form-item label="学校">
                  <el-select v-model="searchForm.schoolId" filterable>
                    <el-option v-for="(item, index) in schoolList" :key="index" :label="item.name" :value="item.id"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="班级">
                  <el-select v-model="searchForm.classId">
                    <el-option label="全部" value=""></el-option>
                    <el-option v-for="(item, index) in selectingClassList" :key="index" :label="item.name" :value="item.id"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="学生姓名">
                  <el-input v-model="searchForm.studentRealName" placeholder="学生姓名"></el-input>
                </el-form-item>
                <el-form-item label="开始日期">
                  <el-date-picker
                    v-model="searchForm.orderDateStart"
                    type="date"
                    placeholder="选择开始日期">
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="结束日期">
                  <el-date-picker
                    v-model="searchForm.orderDateEnd"
                    type="date"
                    placeholder="选择结束日期">
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="套餐内容">
                  <el-input v-model="searchForm.goodsContent" placeholder="套餐内容"></el-input>
                </el-form-item>
                <el-form-item label="订单状态">
                  <el-select v-model="searchForm.status">
                    <el-option label="全部" value=""></el-option>
                    <el-option label="预定中" value="1"></el-option>
                    <el-option label="已锁定" value="2"></el-option>
                    <el-option label="已完成" value="3"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="请假状态" v-if="schoolIdToEnableLeaveMap && schoolIdToEnableLeaveMap[searchForm.schoolId] && schoolIdToEnableLeaveMap[searchForm.schoolId] === '1'">
                  <el-select v-model="searchForm.leaveType">
                    <el-option label="全部" value=""></el-option>
                    <el-option label="不请假" value="0"></el-option>
                    <el-option label="预请假" value="1"></el-option>
                    <el-option label="后请假" value="2"></el-option>
                    <el-option label="取餐时撤销预请假" value="3"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="预定类型">
                  <el-select v-model="searchForm.bookType">
                    <el-option label="全部" value=""></el-option>
                    <el-option label="家长预定" value="1"></el-option>
                    <el-option label="老师预定" value="2"></el-option>
                    <el-option label="超时自动预定" value="3"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="完成类型">
                  <el-select v-model="searchForm.finishType">
                    <el-option label="全部" value=""></el-option>
                    <el-option label="正常取餐" value="1"></el-option>
                    <el-option label="超时自动完成" value="2"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="每页条数">
                  <el-select v-model="pageSize" @change="handleSizeChange" style="width:80px">
                    <el-option v-for="(item, index) in pageSizes" :key="index" :label="item" :value="item"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="getStudentCanteenOrderList">查询</el-button>
                </el-form-item>
              </el-form>
            </el-main>
          </el-container>
        </el-header>
        <el-table v-loading="loading" :data="tableData" border stripe>
          <el-table-column prop="schoolName" label="学校" width="140"></el-table-column>
          <el-table-column prop="className" label="班级" width="80"></el-table-column>
          <el-table-column prop="studentRealName" label="学生姓名" width="80"></el-table-column>
          <el-table-column prop="orderDate" label="日期" width="110"></el-table-column>
          <el-table-column prop="partOfDayName" label="早中晚" width="65"></el-table-column>
          <el-table-column prop="goodsName" label="套餐名称" width="100"></el-table-column>
          <el-table-column prop="goodsDesc" label="套餐描述" width="300"></el-table-column>
          <el-table-column prop="statusName" label="订单状态" width="80"></el-table-column>
          <el-table-column prop="leaveTypeName" label="请假状态" width="80"></el-table-column>
          <el-table-column prop="bookTypeName" label="预定类型" width="80"></el-table-column>
          <el-table-column prop="finishTypeName" label="完成类型" width="80"></el-table-column>
          <el-table-column prop="insertTime" label="创建时间" width="170"></el-table-column>
          <el-table-column prop="creatorRealName" label="创建人" width="90"></el-table-column>
          <el-table-column prop="updateTime" label="修改时间" width="170"></el-table-column>
          <el-table-column prop="updaterRealName" label="修改人" width="90"></el-table-column>
          <el-table-column label="操作" width="141">
            <template slot-scope="scope">
              <el-button v-if="schoolIdToEnableLeaveMap && schoolIdToEnableLeaveMap[searchForm.schoolId] && schoolIdToEnableLeaveMap[searchForm.schoolId] === '1' && ['0', '3'].indexOf(scope.row.leaveType) !== -1" type="text">请假</el-button>
              <el-button v-if="schoolIdToEnableLeaveMap && schoolIdToEnableLeaveMap[searchForm.schoolId] && schoolIdToEnableLeaveMap[searchForm.schoolId] === '1' && ['1', '2'].indexOf(scope.row.leaveType) !== -1" type="text">取消请假</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div>
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="getStudentCanteenOrderList"
            :current-page.sync="currentPage"
            :page-sizes="pageSizes"
            :page-size="pageSize"
            :total="total"
            layout="total,sizes,prev,pager,next" >
          </el-pagination>
        </div>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import Top from './Top.vue'
import Menu from './Menu.vue'
export default ({
  components: {
    Menu,
    Top
  },
  data () {
    return {
      userInfo: {},
      tableData: [],
      loading: false,
      currentPage: 1,
      pageSize: 15,
      pageSizes: [15, 50, 100, 150, 200, 300, 500, 1000, 2000],
      total: 0,
      searchForm: {
        schoolId: '',
        classId: '',
        studentRealName: '',
        goodsContent: '',
        orderDateStart: null,
        orderDateEnd: null,
        status: '',
        leaveType: '',
        bookType: '',
        finishType: ''
      },
      schoolList: [],
      classList: [],
      schoolIdToEnableLeaveMap: {}
    }
  },
  mounted () {
    if (this.Cookie.get('userInfo') !== undefined && this.Cookie.get('userInfo') !== '') {
      this.userInfo = JSON.parse(this.Cookie.get('userInfo'))
      this.getSchoolList()
      this.getClassList()
    }
  },
  methods: {
    goto (url) {
      if (url === this.$route.path) return
      this.$router.push(url)
    },
    handleSizeChange (pageSize) {
      this.pageSize = pageSize
      this.getStudentCanteenOrderList()
    },
    getSchoolList () {
      let _this = this
      this.$axios.post(this.GLOBAL.host + '/school/list',
        this.$qs.stringify({
          currentUserId: _this.userInfo.id
        })
      ).then(res => {
        if (res.data != null) {
          if (res.data.status === 200) {
            _this.schoolList = res.data.data.list
            if (_this.schoolList.length > 0) {
              _this.searchForm.schoolId = _this.schoolList[0].id
              _this.schoolList.forEach(item => {
                if (item.id) {
                  _this.schoolIdToEnableLeaveMap[item.id] = item.enableLeaveInStudentCanteen
                }
              })
              _this.getStudentCanteenOrderList()
            }
          } else {
            this.$message.error(res.data.message)
          }
        }
      })
    },
    getClassList () {
      let _this = this
      this.$axios.post(this.GLOBAL.host + '/class/list',
        this.$qs.stringify({
          currentUserId: _this.userInfo.id,
          filterNotGraduated: true
        })
      ).then(res => {
        if (res.data != null) {
          if (res.data.status === 200) {
            if (res.data.data != null && res.data.data.list != null) {
              _this.classList = res.data.data.list
            }
          } else {
            this.$message.error(res.data.message)
          }
        }
      })
    },
    getStudentCanteenOrderList () {
      let _this = this
      _this.loading = true
      this.$axios.post(this.GLOBAL.host + '/studentCanteenOrder/list', {
        schoolId: _this.searchForm.schoolId,
        classId: _this.searchForm.classId,
        studentRealNameLike: _this.searchForm.studentRealName,
        orderDateGreaterThanAndEqual: _this.searchForm.orderDateStart,
        orderDateLessThanAndEqual: _this.searchForm.orderDateEnd,
        goodsContentLike: _this.searchForm.goodsContent,
        status: _this.searchForm.status,
        leaveType: _this.searchForm.leaveType,
        bookType: _this.searchForm.bookType,
        finishType: _this.searchForm.finishType,
        page: _this.currentPage,
        size: _this.pageSize
      }).then(res => {
        if (res.data != null) {
          if (res.data.status === 200) {
            _this.total = res.data.data.total
            _this.tableData = res.data.data.list
          } else {
            this.$message.error(res.data.message)
          }
        }
        _this.loading = false
      })
    }
  },
  computed: {
    selectingClassList () {
      let tempArray = []
      if (this.searchForm.schoolId != null && this.searchForm.schoolId !== '' && this.classList.length > 0) {
        this.classList.forEach(classInfo => {
          if (classInfo.schoolId === this.searchForm.schoolId) {
            tempArray.push(classInfo)
          }
        })
      } else {
        tempArray = this.classList
      }
      return tempArray
    }
  },
  watch: {
    selectingClassList () {
      if (this.searchForm.classId != null && this.searchForm.schoolId !== '' && this.selectingClassList.map(item => item.id).indexOf(this.searchForm.classId) === -1) {
        this.searchForm.classId = ''
      }
    }
  }
})
</script>



// WEBPACK FOOTER //
// src/components/StudentCanteenOrder.vue